<template>
  <page-outline :title="pageTitle">
    <template slot="pageContent">
      <b-container fluid>
        <b-row class="justify-content-start mb-5">
          <b-col cols="4" lg="2" xl="1">
            <back-button :returnUrl="returnUrl"></back-button>
          </b-col>
        </b-row>
        <spinner v-if="activateSpinner"></spinner>
        <vop-provider-form :mode="mode" :readonly="!isEditable" v-model="config" v-else></vop-provider-form>
        <b-row class="justify-content-end">
          <b-col cols="4" lg="2" xl="1" v-if="isEditable && formType !== 'add'">
            <b-button variant="primary"
              @click="switchMode('details')">
              <span>{{ $t('common.cncl') }}</span>
            </b-button>
          </b-col>
          <b-col cols="4" lg="2" xl="1" v-if="!isEditable && formType !== 'add'">
            <b-button variant="primary"
              @click="switchMode('edit')">
              <i class="fa-light fa-pencil"></i>
              <span>{{ $t('administration.edit') }}</span>
            </b-button>
          </b-col>
          <b-col cols="4" lg="2" xl="1" v-if="!isEditable && formType !== 'add'">
            <b-button variant="primary"
              @click="deleteVopProvider">
              <i class="fa-light fa-trash"></i>
              <span>{{ $t('rights.delete') }}</span>
            </b-button>
          </b-col>
          <b-col cols="4" lg="2" xl="1" v-if="isEditable && formType !== 'add'">
            <b-button variant="primary"
              @click="editVopProvider">
              <i class="fa-light fa-save"></i>
              <span>{{$t('common.sve')}}</span>
            </b-button>
          </b-col>
          <b-col cols="4" lg="2" xl="1" v-if="mode === 'add'">
            <b-button variant="primary"
              @click="addVopProvider">
              <i class="fa-light fa-save"></i>
              <span>{{$t('common.sve')}}</span>
            </b-button>
          </b-col>
        </b-row>
      </b-container>
    </template>
  </page-outline>
</template>

<script>
import PageOutline from '@/components/common/PageOutline.vue'
import {errorMessageAlert} from '@/helpers/alert'
import backButton from "@/components/common/backButton.vue"
import Spinner from '@/components/common/spinner.vue'
import VopProviderForm from '@/pages/vopProvider/VopProviderForm.vue'
import {loadPage} from '@/helpers/routing'

export default {
  name: "VopProviderDetails",
  components: {
    'back-button': backButton,
    'vop-provider-form': VopProviderForm,
    'page-outline': PageOutline,
    'spinner': Spinner
  },
  props: {
    mode: {
      type: String,
      default: "add"
    },
    id: {
      type: String,
      default: '-1'
    }
  },
  computed: {
    isEditable () {
      return this.formType === 'add' || this.formType === 'edit'
    },
    pageTitle() {
      switch (this.mode) {
        case 'edit':
          return this.$t('Webheader.vop_provider_edit')
        case 'details':
          return this.$t('Webheader.vop_provider_details')
        case 'add':
        default:
          return this.$t('Webheader.vop_provider_add')
      }
    }
  },
  data() {
    return {
      activateSpinner: false,
      vopProvider: '',
      returnUrl: '',
      currentVopProvider: {},
      savedConfig: [],
      config: {},
      originalConfig: {},
      formType: 'add'
    }
  },
  created() {
    this.activateSpinner = true
    this.formType = this.mode

    this.returnUrl = '/vopProvider/'

    if(this.id !== '-1' && (this.mode === "details" || "edit")) {
      this.getVopProvider()
    } else {
      this.activateSpinner = false
    }
  },
  methods: {
    addVopProvider () {
      let that = this

      if (this.formHasError()) {
        return
      }

      let params = {
        NameVopProvider: this.config.NameVopProvider,
        IdVopProvider: this.IdVopProvider
      }
      this.$engine.vopProvider.addVopProvider(params)
      .then(resp => {
        that.$f7.modal({
          title: that.$t('common.vop_provider.vop_provider_added'),
          buttons: [
            {
              text: 'OK',
              onClick: function () {
                return
              }
            }
          ]
        })
        loadPage(that, {url: '/vopProvider/'})
      })
      .catch((e) => {
        if (e.response.status === 400 && e.response.data.errors) {
          const errors = e.response.data.errors

          errors.forEach((error) => {
            if (error.error === "Invalid NameVopProvider") {
              that.okMessageBox(that.$t('common.vop_provider.name_exist_db'))
            }
          })
        } else {
          errorMessageAlert(e, that)
        }
      })
    },
    deleteVopProvider () {
      let that = this
      this.$f7.modal({
        title: this.$t('common.vop_provider.element_deletion_confirm'),
        buttons: [
          {
            text: this.$t('creation_forms.vldt'),
            onClick: function () {
              let params = {
                IdVopProvider: that.id
              }
              that.$engine.vopProvider.deleteVopProvider(params)
              .then(resp => {
                that.$f7.modal({
                  title: that.$t('common.vop_provider.vop_provider_deleted'),
                  buttons: [
                    { text: 'OK', onClick: function () { return } }
                  ]
                })
                loadPage(that, {url: '/vopProvider/'})
              })
              .catch((e) => {
                if (e.response.status === 400 && e.response.data.errors) {
                  const errors = e.response.data.errors

                  errors.forEach((error) => {
                    if (error.error === "Deletion Error") {
                      that.okMessageBox(that.$t('common.vop_provider.unable_del'))
                    }
                  })
                } else {
                  errorMessageAlert(e, that, that.$i18n)
                  that.okMessageBox(that.$t('common.vop_provider.vop_provider_delete_error'))
                }
              })
            }
          },
          {
            text: this.$t('common.cncl'),
            onClick: function () {
              return
            }
          }
        ]
      })
    },
    editVopProvider () {

      if (this.formHasError()) {
        return
      }

      let that = this
      let params = {
        IdVopProvider: this.id,
        NameVopProvider: this.config.NameVopProvider
      }
      this.$engine.vopProvider.editVopProvider(params)
      .then(resp => {
        that.$f7.modal({
          title: that.$t('common.vop_provider.vop_provider_edited'),
          buttons: [
            {
              text: 'OK',
              onClick: function () {
                return
              }
            }
          ]
        })
        loadPage(that, {url: '/vopProvider/'})
      })
      .catch((e) => {
        if (e.response.status === 400 && e.response.data.errors) {
          const errors = e.response.data.errors

          errors.forEach((error) => {
            if (error.error === "Invalid NameVopProvider") {
              that.okMessageBox(that.$t('common.vop_provider.name_exist_db'))
            }
          })
        } else {
          errorMessageAlert(e, that, that.$i18n)
        }
      })
    },
    fillFields () {
      this.config = this.currentVopProvider
      this.originalConfig = this.currentVopProvider
      this.activateSpinner = false
    },
    formHasError () {
      if (this.config.NameVopProvider === undefined || this.config.length === 0) {
        this.okMessageBox(this.$t('common.vop_provider.name_missing'))
        return true
      }
      return false
    },
    getVopProvider () {
      this.$engine.vopProvider.getVopProvider({})
      .then(resp => {
        let that = this
        let vopProviderList = {}

        vopProviderList = resp.data.VopProvider

        that.updateVopProvider(vopProviderList)
      })
      .catch(error => {
        errorMessageAlert(error, that)
      })
    },
    okMessageBox (message) {
      this.$f7.modal({
        title: message,
        buttons: [
          {
            text: 'OK',
            onClick: function () {
              return
            }
          }
        ]
      })
    },
    switchMode (mode) {
      if (mode === 'details' && this.formType === 'edit') {
        this.config = this.originalConfig
      }
      this.formType = mode
    },
    updateVopProvider(vopProviderList){
      const selectedVopProvider = vopProviderList.find(vopProvider => vopProvider.IdVopProvider === this.id)
      this.currentVopProvider = selectedVopProvider
      this.fillFields()
    }
  }
}
</script>
